<template>
  <b-overlay :show="isLoading" variant="white" opacity="0.6" rounded="sm">
    <div>
      <b-form class="form-autorequired" @submit.prevent >
        <TextField
            id="meloginId"
            fieldname="loginId"
            label="ユーザーID"
            :viewmode="true"
            :disperror="true"
            :validators="[]"
            v-model="record.loginId"
        />
        <PasswordField
            ref="passwd"
            id="passwd"
            fieldname="passwd"
            label="パスワード"
            :placeholder="$t('MESSAGE.passwdUpdate')"
            :viewmode=false
            :disperror=true
            :validators="['maxlength']"
            v-model="record.passwd"
            @updateValue="checkPassword"
        />
        <PasswordField
            ref="passwdconf"
            id="passwdconf"
            fieldname="passwdconf"
            label="パスワード（再入力）"
            :placeholder="$t('MESSAGE.passwdUpdate')"
            :viewmode=false
            :disperror=true
            :validators="['maxlength']"
            v-model="passwdConf"
            @updateValue="checkPassword"
        />
        <TextField
            ref="userName"
            id="userName"
            fieldname="userName"
            label="ユーザー名"
            :viewmode=false
            :disperror=true
            :validators="['required', 'maxlength']"
            :maxlength=20
            v-model="record.userName"
        />
        <MultiselectField
            id="roles"
            fieldname="roles"
            label="権限"
            :viewmode=true
            :disperror=true
            :validators="['required']"
            v-model="record.roles"
            :options="$t('DIC.roles')"
        />
        <b-form-group
            label="最終ログイン"
        >
          <TextField
              id="loginDate"
              fieldname="loginDate"
              label="日時"
              :viewmode="true"
              :value="$moment(record.loginDate).format('YYYY/MM/DD HH:mm')"
          />
          <TextField
              id="loginIpaddress"
              fieldname="loginIpaddress"
              label="IP Address"
              :viewmode="true"
              v-model="record.loginIpaddress"
          />
          <TextField
              id="loginAgent"
              fieldname="loginAgent"
              label="UserAgent"
              :viewmode="true"
              v-model="record.loginAgent"
          />
        </b-form-group>
      </b-form>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <b-button variant="secondary" @click="closeEdit('cancel')"><font-awesome-icon icon="times-circle" /> 閉じる</b-button>
      </div>
      <div class="col text-right">
        <b-button variant="success" @click="updateTask"><font-awesome-icon icon="check-circle" /> 変 更</b-button>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { useQuery, useResult, useMutation } from '@vue/apollo-composable'
import TextField from '@/components/fields/TextField'
import RadioField from '@/components/fields/RadioField'
import PasswordField from '@/components/fields/PasswordField'
import MultiselectField from '@/components/fields/MultiselectField'
import { GET_USER, UPDATE_USER } from '@/graphql'
import updateTokenMixin from '@/mixins/updateTokenMixin.js'
import { cloneObject, extendObject, copyObject, refValidate } from '@/lib/utils.js'

// 新規用の初期化設定
const initRecord = {
  userId: '0',
  state: '1',
  loginId: '',
  passwd: '',
  userName: '',
  roles: '',
  loginDate: '',
  loginIpaddress: '',
  loginAgent: ''
}

export default {
  mixins: [updateTokenMixin],
  components: { TextField, PasswordField, RadioField, MultiselectField },
  props: {
    userId: { type: String, default: '0', required: false }
  },
  setup (props) {
    let form = {
      passwd: '',
      userId: '',
      loginId: '',
      userName: '',
      state: '',
      roles: ''
    }
    // パスワード確認
    let passwdConf = ''
    // QUERY
    const { result, loading, error, refetch, onError: onError2updateToken } = useQuery(
      GET_USER,
      {
        userId: props.userId
      },
      {
        // 新規の場合は読み込まないように
        enabled: !props.newdata,
        // キャッシュせず常にgraphqlからデータを取得
        fetchPolicy: 'network-only'
      }
    )
    // resultで受け取ったデータの設定
    const record = useResult(result, cloneObject(initRecord),
      data => data.getUser ? extendObject(form, data.getUser) : cloneObject(initRecord)
    )
    // update
    const { mutate: updateUser, loading: updateLoading } = useMutation(UPDATE_USER)

    // updateTokenMixinを使う時は 対象Queryの onError, refetch を返す
    return {
      form,
      passwdConf,
      record,
      result,
      loading,
      error,
      refetch,
      updateUser,
      updateLoading,
      onError2updateToken
    }
  },
  computed: {
    isLoading () {
      return this.loading || this.updateLoading
    }
  },
  methods: {
    checkPassword (e) {
      if (this.record.passwd !== this.passwdConf) {
        this.$refs['passwd'].setInvaidated('VALIDATE.unmatchedPassword')
      } else {
        this.$refs['passwd'].resetInvaidated()
      }
    },
    updateTask () {
      // formにrecordをcopy
      copyObject(this.form, this.record)
      // エラー表示モードに切り替え
      this.formDispError = true
      // ref設定したFieldを一括validateする
      if (!refValidate(this.$refs, this.form)) {
        return false
      }
      // パスワードの一致を確認
      if (this.form.passwd !== this.passwdConf) {
        this.checkPassword()
        return false
      }
      this.$swal(this.$t('PAGES.Me.SWAL.update'))
        .then((result) => {
          // キャンセルボタンなら処理しない
          if (!result.isConfirmed) return
          // update処理
          this.updateUser(this.form)
            .then(data => {
              let result = data.data.updateUser
              if (result.status) {
                this.$store.commit('auth/rename', this.record)
                // 完了Toast発行
                this.$store.dispatch('toast/showToast', {
                  title: this.$t('PAGES.Me.title'),
                  message: this.$t('MESSAGE.updateSuccess'),
                  variant: 'success'
                })
                this.closeEdit('update')
              } else {
                // エラー処理
                this.$store.commit('setError', result.message)
              }
            })
            .catch(err => {
              // 異常終了処理
              this.$store.commit('setError', err)
            })
        })
    },
    closeEdit (action) {
      this.$emit('close', {action: action})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Me.vue